import { render, staticRenderFns } from "./SearchByBarcode.vue?vue&type=template&id=58b4d96e&scoped=true&"
import script from "./SearchByBarcode.vue?vue&type=script&lang=js&"
export * from "./SearchByBarcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b4d96e",
  null
  
)

export default component.exports